import axios from 'axios';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { Location, getConfiguration } from '../models';

const search = async (query: string): Promise<Location[]> => {
    const result = await axios(
        `${getConfiguration().serviceEndpoint}/miestai.cfm?t=2&q=${query}`
    );
    return result.data;
};

export const performLocationSearch = AwesomeDebouncePromise(search, 300);